var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeals = function SvgDeals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 370.35 410.5",
    fill: "currentColor",
    width: "1em",
    height: "1em",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m339.91 229.29-5.13-5.13-127-127-26.57-26.57A36.1 36.1 0 0 0 156 60.18H35.7A35.82 35.82 0 0 0 0 95.81V216.1a35.48 35.48 0 0 0 10.48 25.22L169.19 400a35.57 35.57 0 0 0 50.3.13l.13-.13 120.29-120.2a35.88 35.88 0 0 0 0-50.51ZM106.84 167c-26.16 24.75-63.51-12.54-38.63-38.68 26.23-24.74 63.43 12.55 38.63 38.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.92 169.19 201.22 10.48A35.39 35.39 0 0 0 176.08 0H55.78a35.69 35.69 0 0 0-35.69 35.69v12.4c4.64-5 127-1.66 135.9-2.57a50.74 50.74 0 0 1 35 14.15L350.25 219a47.39 47.39 0 0 1 4.83 5.57 36.57 36.57 0 0 0 4.84-55.34Z"
  })));
};
export default SvgDeals;